/**
 * Últimas páginas visitadas, para a paleta "Ir para…". Por pessoa, no
 * armazenamento local do navegador; sem ele (modo privado, bloqueio), só na
 * memória desta aba.
 */
export type RecentPage = {
  /** Só o caminho, sem a busca: a mesma página com outro filtro é uma só. */
  path: string;
  title: string;
  /** Os níveis de antes no breadcrumb (a seção do menu, ao menos). */
  section?: string;
};

export const RECENT_PAGES_LIMIT = 6;

const memory = new Map<string, RecentPage[]>();

const storageKey = (userUid: string) => `ops-panel:recentes:${userUid}`;

const isRecentPage = (value: any): value is RecentPage =>
  Boolean(value) &&
  typeof value.path === 'string' &&
  typeof value.title === 'string' &&
  (value.section === undefined || typeof value.section === 'string');

export const readRecentPages = (userUid: string): RecentPage[] => {
  const key = storageKey(userUid);
  try {
    const raw = window.localStorage.getItem(key);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.filter(isRecentPage).slice(0, RECENT_PAGES_LIMIT);
      }
    }
  } catch (error) {
    // Sem armazenamento ou valor estragado: vale a memória
  }
  return memory.get(key) || [];
};

/** Põe a página na frente (uma vez só) e devolve a lista nova. */
export const pushRecentPage = (
  userUid: string,
  page: RecentPage
): RecentPage[] => {
  const key = storageKey(userUid);
  const next = [
    page,
    ...readRecentPages(userUid).filter(({path}) => path !== page.path),
  ].slice(0, RECENT_PAGES_LIMIT);
  memory.set(key, next);
  try {
    window.localStorage.setItem(key, JSON.stringify(next));
  } catch (error) {
    // Sem armazenamento: fica a memória
  }
  return next;
};
